import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'smart-fix-feedback-modal',
  templateUrl: './smart-fix-feedback-modal.html',
  styleUrls: ['./smart-fix-feedback-modal.scss'],
  standalone: true,
})
export class SmartFixFeedbackModalComponent implements OnInit {
  feedbackTickSvg: SafeHtml | null = null;

  constructor(private sanitizer: DomSanitizer, private http: HttpClient) {}

  ngOnInit(): void {
    this.http
      .get('/assets/svg/smart-fix-feedback-modal.svg', { responseType: 'text' })
      .subscribe((file) => {
        this.feedbackTickSvg = this.sanitizer.bypassSecurityTrustHtml(file);
      });
  }
}
